export class MessageContentTemplate {
    text:string;
    templateFields: Array<string>;
    renderedText?: string;
    templateId: number;
    templateName:string;
}
